import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import styles from './ep-pricing-esm-components-total-price-total-price.module.scss.js';
import { clsx } from './ep-pricing-esm-external-clsx-dist-clsx.js';
import { useScreenClass, FlexBox, ErrorBoundary, ScreenClassProvider } from '@vp/swan';
import { PriceInternal } from './ep-pricing-esm-components-price-price.component.js';
import { UnitPriceWithQuantityInternal } from './ep-pricing-esm-components-unit-price-with-quantity-unit-price-with-quantity.component.js';
import { VatMessageInternal } from './ep-pricing-esm-components-vat-message-vat-message.component.js';
import { AlignVAT } from './ep-pricing-esm-types-vat.types.js';
import { UnitPriceInternal } from './ep-pricing-esm-components-unit-price-unit-price.component.js';
import { UnitsCountInternal } from './ep-pricing-esm-components-units-count-units-count.component.js';
import { getPrice } from './ep-pricing-esm-utils-price.util.js';

const TotalPriceInternal = forwardRef((props, ref) => {
  const { className, totalPriceConfig, alignVAT = AlignVAT.BOTTOM, isTile = false, placeholdertext, ...rest } = props;
  const classNames = clsx(className, styles.totalPrice);
  const { listPrice, discountedListPrice, unitListPrice, unitDiscountedPrice, quantity, vatInc = false, locale, shippingIncl, hideShippingMessageInVatMessage } = totalPriceConfig;
  const screenClass = useScreenClass();
  const renderPrice = (isBold) => /* @__PURE__ */ jsx(PriceInternal, { priceConfig: totalPriceConfig, placeholdertext, fontSkin: isTile ? "body-small" : "title-subsection", fontWeight: isBold ? "bold" : "normal" });
  const renderVatMessage = () => {
    return /* @__PURE__ */ jsx(
      VatMessageInternal,
      {
        locale: totalPriceConfig.locale,
        vatAndShippingConfig: { vatInc, shippingIncl, hideShippingMessageInVatMessage },
        placeholdertext,
        fontSkin: isTile ? "footnote" : "body-small"
      }
    );
  };
  const renderUnitPriceAndQuantity = () => {
    if (unitListPrice && unitDiscountedPrice && quantity) {
      return /* @__PURE__ */ jsx(
        UnitPriceWithQuantityInternal,
        {
          unitPriceConfig: { ...totalPriceConfig, unitListPrice, unitDiscountedPrice, quantity },
          placeholdertext,
          fontSkin: isTile ? "footnote" : "body-small"
        }
      );
    }
    if (unitListPrice && unitDiscountedPrice) {
      return /* @__PURE__ */ jsx(
        UnitPriceInternal,
        {
          unitPriceConfig: { ...totalPriceConfig, unitListPrice, unitDiscountedPrice },
          placeholdertext,
          fontSkin: isTile ? "footnote" : "body-small"
        }
      );
    }
    if (quantity) {
      return /* @__PURE__ */ jsx(UnitsCountInternal, { locale, quantity, placeholdertext, fontSkin: isTile ? "footnote" : "body-small" });
    }
    return null;
  };
  const isDiscountedPriceBetter = getPrice(listPrice, vatInc) > getPrice(discountedListPrice, vatInc);
  const renderTotalPriceWithVatAlignedRight = () => /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsxs(FlexBox, { gap: 2, alignItems: "center", children: [
      renderPrice(!isDiscountedPriceBetter),
      renderVatMessage()
    ] }),
    renderUnitPriceAndQuantity()
  ] });
  const renderTotalPriceWithVatAlignedBottom = () => /* @__PURE__ */ jsxs(Fragment, { children: [
    renderPrice(!isDiscountedPriceBetter),
    renderUnitPriceAndQuantity(),
    renderVatMessage()
  ] });
  return /* @__PURE__ */ jsx(FlexBox, { flexDirection: "column", gap: 1, className: classNames, ...rest, ref, children: alignVAT === AlignVAT.RIGHT && screenClass !== "xs" ? renderTotalPriceWithVatAlignedRight() : renderTotalPriceWithVatAlignedBottom() });
});
const TotalPrice = forwardRef((props, ref) => /* @__PURE__ */ jsx(ErrorBoundary, { fallback: /* @__PURE__ */ jsx(FlexBox, { fontSize: "large", children: props.placeholdertext }), children: /* @__PURE__ */ jsx(ScreenClassProvider, { children: /* @__PURE__ */ jsx(TotalPriceInternal, { ...props, ref }) }) }));

export { TotalPrice };
//# sourceMappingURL=ep-pricing-esm-components-total-price-total-price.component.js.map
